import {notification, message} from 'antd';
// data type
import {IconType} from 'antd/lib/notification/index';

export const getPopupNode = () => {
    return document.getElementById('scroll-body') || document.body;
};
export const getPopupNodeModal = (node: any) => {
    return node? node.parentNode : document.body
};

export const get_domain = () => {
    const hostname: string = window.location.hostname;
    const domain: string = hostname.slice(hostname.indexOf('.'));
    return {path: '/', domain: domain, maxAge: 3600}
};

export const get_router = (props: any, ssoRole: string) => {
    const {pathname} = props.location;
    switch (pathname) {
        case '/': return ssoRole === 'globalAdmin'? 'overview': 'serviceInstance';
        case '/service-list': return 'serviceInstance';
        case '/create-secret': return 'secretManagement';
        case '/resource-management/overview': return 'overview';
        case '/resource-management/service-management': return 'serviceManagement';
        default: return 'null';
    }
};

// 格式化时间
export const format_time = (date: any) => {
    const time = new Date(date);
    const year = time.toLocaleDateString(),
        hours = time.getHours() < 10 ? `0${time.getHours()}` : time.getHours(),
        minutes = time.getMinutes() < 10 ? `0${time.getMinutes()}` : time.getMinutes(),
        seconds = time.getSeconds() < 10 ? `0${time.getSeconds()}` : time.getSeconds();
    return `${year} ${hours}:${minutes}:${seconds}`;
};

export const upper_case_first = (str: string| undefined) => {
    switch (str) {
        case 'enable': return 'Enabled';
        case 'disable': return 'Disabled';
        case 'inprogress': return 'In Progress';
        case 'Inprogress': return 'In Progress';
        default: return str? `${str.slice(0,1).toUpperCase()}${str.slice(1)}`: str;
    }
};

export const sorterString = (a: any, b: any, key: string) => {
    const v1: string = (a[key] || '').toUpperCase(),
        v2: string = (b[key] || '').toUpperCase();
    return v1< v2? -1: v1 === v2? 0: 1;
};

export const sorterDate = (a: any, b: any, key: string) =>{
    const date1: any = new Date(a[key]),
        date2: any = new Date(b[key]),
        v1: number = Date.UTC(date1.getFullYear(), date1.getMonth(), date1.getDate(), date1.getHours(), date1.getMinutes(), date1.getSeconds()),
        v2: number = Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds());
    return v1< v2? -1: v1 === v2? 0: 1;
};

// 页面跳转
export const router_link = (props: any, link: string, query?: any) => {
    props.history.push({pathname: link, query: query});
};

// 提示框
export const alert = (type: IconType, title?: string, msg?: string) => {
    // type: success, info, warning, error
    notification[type]({
        message: title,
        description: msg
    })
};

export const user_selected_content_sidebar = (list: any, set_fun: any) => {
    const session_selected : string | null =sessionStorage.getItem('content_sidebar_selected');
    let new_selected: string | undefined | null;
    if(session_selected){
        for(let i = 0; i< list.length; i++){
            if(list[i].key === session_selected){
                new_selected = list[i].key
            }else if(i === list.length-1){
                new_selected = list[0].key
            }
        }
    }else {
        new_selected = list[0].key
    }
    setTimeout(()=>set_fun(new_selected),100);
    return new_selected;
};

export const random_uuid = () => {
    const UUIDv4: string= '0123456789abcdef';
    let random_UUID: string ='';
    for (let i=0; i<32; i++){
        const random: number = Math.floor(Math.random()*16);
        i%4 === 0 && i/4>=2 && i/4<=5 && (random_UUID += '-');
        random_UUID += UUIDv4.slice(random, random+1);
    }
    return random_UUID;
};

let loading: any = [];
let loading_action: any;

export function loading_alert_toggle() {
    if(loading.length === 1 ) {
        if (loading[0] === 'show_loading') {
            loading_action = message.loading('', 0)
        }
        if (loading[0] === 'hide_loading') {
            loading_action();
            loading = [];
        }
    }
}

export function loading_alert_before(){
    if(loading.length<= 0){
        loading=['show_loading']
    }else {
        loading.unshift(1);
    }
    loading_alert_toggle();
}

export function loading_alert_after(){
    if(loading.length <= 1){
        loading =['hide_loading'];
    }else {
        loading.pop()
    }
    loading_alert_toggle()
}

export function close_loading() {
    if(loading_action){
        loading = [];
        loading_action();
    }
}
